module.exports = "<div>\n  {{$ctrl.getHelpText()}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/modalDelegationManager/modalCreateDelegation/createDelegationHelp/createDelegationHelp.html
// module id = 922
// module chunks = 0